import { DataObject } from '@/utils/DataObject'
import { ProfileArtwork } from './ProfileArtwork'
import { MediaTransformer } from '../media/MediaTransformer'
import { ArtistTransformer } from '../artist/ArtistTransformer'

export class ProfileArtworkTransformer {

  private parseMEdia(data: DataObject = {}) {
    if (data['media'] && data['media'] instanceof Array) {
      return data['media'].map((obj: DataObject) => new MediaTransformer().toClass(obj))
    } else {
      return new MediaTransformer().toClass(data['media'])
    }
  }

  private parseDimension(data: DataObject = {}): string {
    if (!data.height && !data.width && !data.depth) return ''
    return `${data.height}H x ${data.width}W x ${data.depth}D [cm]`
  }

  public toClass(data: DataObject = {}): ProfileArtwork {
    return new ProfileArtwork({
      id: data.id,
      title: data.title,
      slug: data.slug,
      description: data.description,
      price: data.price,
      category_id: data.category ? data.category.id : null,
      technique_id: data.technique ? data.technique.id : null,
      width: data.width,
      height: data.height,
      depth: data.depth,
      weight: data.weight,
      vat_rate: data.vat_rate,
      themes: data.themes ? data.themes.map((theme: any) => theme.id) : [],
      isForSale: !!data.is_for_sale,
      is_visible: !!data.is_visible,
      is_active: !!data.is_active,
      is_framed: !!data.is_framed,
      is_hang_ready: !!data.is_hang_ready,
      is_published: !!data.is_published,
      created_year: data.created_year,
      media: this.parseMEdia(data),
      artist: new ArtistTransformer().toClass(data.artist),
      dimension: this.parseDimension(data),
      path: data.path,
      favorite_id: data.favorite_id,
      my_subscription_id: data.my_subscription_id,
      keywords: data.keywords,
      isTestable: data.is_testable,
      locked_until: data.locked_until || null,
      video_id: data.video_id,
      is_video_approved: data.is_video_approved,
    })
  }

}
